export interface KpiValue {
  curr: number;
  prev: number;
}

export interface TrxKpiModel {
  nb: KpiValue;
  paid: KpiValue;
  payout: KpiValue;
  earnings: KpiValue;
  credit: KpiValue;
}

export interface OrderKpiModel {
  nb: KpiValue;
  cogs: KpiValue;
  earnings: KpiValue;
  debit: KpiValue;
  thumbs: {
    up: KpiValue;
    down: KpiValue;
  };
}

export interface UserKpiModel {
  new: KpiValue;
  returning: KpiValue;
  active: KpiValue;
  avgPayout: KpiValue;
}

export interface GlobalKpiModel {
  stock: {
    amount: number;
    vouchers: number;
    value: number;
  };
  lastOrder: {
    date: Date;
    product: string;
  };
  lastPayment: {
    date: Date;
    type: string;
    amount: number;
  }
  supportTickets: number;
}

export interface KpiModel {
  trx: TrxKpiModel
  order: OrderKpiModel;
  user: UserKpiModel;
  balance: number;
  kpi: GlobalKpiModel;
}

export const initialKpi = {
  trx: {
    nb: { curr: 0, prev: 0 },
    paid: { curr: 0, prev: 0 },
    payout: { curr: 0, prev: 0 },
    earnings: { curr: 0, prev: 0 },
    credit: { curr: 0, prev: 0 },
  },
  order: {
    nb: { curr: 0, prev: 0 },
    cogs: { curr: 0, prev: 0 },
    earnings: { curr: 0, prev: 0 },
    debit: { curr: 0, prev: 0 },
    thumbs: {
      up: { curr: 0, prev: 0 },
      down: { curr: 0, prev: 0 },
    },
  },
  user: {
    new: { curr: 0, prev: 0 },
    returning: { curr: 0, prev: 0 },
    active: { curr: 0, prev: 0 },
    avgPayout: { curr: 0, prev: 0 },
  },
  balance: 0,
  kpi: {
    stock: { amount: 0, vouchers: 0, value: 0},
    lastOrder: { date: new Date (), product: ''},
    lastPayment: { date: new Date(), type: '', amount: 0},
    supportTickets: 0
  }
};

